import Image from 'next/image';
import querystring from 'query-string';
import React from 'react';

import deliveryImageUrl from '@/assets/localities/see-whats-available/delivery.jpg';
import drivableImageUrl from '@/assets/localities/see-whats-available/drivable.jpg';
import petFriendlyImageUrl from '@/assets/localities/see-whats-available/pet-friendly.jpg';
import towableImageUrl from '@/assets/localities/see-whats-available/towable.jpg';
import under150ImageUrl from '@/assets/localities/see-whats-available/under-150.jpg';
import AspectRatio from '@/components/common/AspectRatio';
import { EHeaderTab } from '@/components/ui/SearchHeader/UniversalSearch/UniversalSearchContainer/menu';
import { trackRenterSearchedEvent } from '@/services/analytics/search';
import { ERentalType } from '@/services/analytics/types';
import { trackEvent } from '@/services/track-event';
import { LocationGroupType } from '@/utility/surfacedLocation';

import css from './SeeWhatsAvailable.module.css';

type TSeeWhatsAvailableProps = {
  address: string;
};

const SeeWhatsAvailable = ({ address }: TSeeWhatsAvailableProps) => {
  return (
    <ul className={css.rigsList}>
      {rigs.map(({ params, image, name }) => {
        return (
          <li key={name} className={css.rigItem}>
            <button
              title={name}
              onClick={async () => {
                trackEvent({
                  event: 'Locality : Clicked carousel item',
                  data: { typeOf: 'rig', name },
                });

                await trackRenterSearchedEvent({
                  surfacedLocations: LocationGroupType.OTHER,
                  totalAdults: null,
                  totalChildren: null,
                  totalInfants: null,
                  locationQuery: null,
                  source: 'serp_canned_filter',
                  isADAAccessible: false,
                  isPetFriendly: false,
                  flexibleDateRange: null,
                  departureDate: null,
                  returnDate: null,
                  hasCategories: false,
                  selectedCategory: EHeaderTab.ALL,
                  towableYear: null,
                  towableMake: null,
                  towableModel: null,
                  rentalType: ERentalType.RV,
                  searchFilterCategory: null,
                  lastQuestionSeen: null,
                });

                window.location.href = `/rv-search?${querystring.stringify({
                  address,
                  ...params,
                })}`;
              }}
              className="w-full h-full text-left">
              <AspectRatio
                ratio="1:1"
                hasImageHover={true}
                className="bg-gray-200 shadow rounded-xl md:rounded-xl hover:shadow-lg">
                <Image src={image} alt={name} layout="fill" objectFit="cover" loading="lazy" />
              </AspectRatio>

              <div className="mt-4 text-lg font-medium text-gray-900">{name}</div>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default SeeWhatsAvailable;

const rigs = [
  {
    name: 'Drivable',
    image: drivableImageUrl,
    params: { 'filter[type]': 'c,a,camper-van,b,truck-camper,other' },
  },
  {
    name: 'Pet friendly',
    image: petFriendlyImageUrl,
    params: { 'filter[feature]': 'pet_friendly' },
  },
  {
    name: 'Towable',
    image: towableImageUrl,
    params: { 'filter[type]': 'trailer,fifth-wheel,toy-hauler,folding-trailer' },
  },
  {
    name: 'Delivery',
    image: deliveryImageUrl,
    params: { delivery: 'true', deliveryStationary: 'stationary' },
  },
  {
    name: 'Under $150',
    image: under150ImageUrl,
    params: { 'price[max]': '15000' },
  },
];
